import { render, staticRenderFns } from "./orderTopInfo.vue?vue&type=template&id=5b3d9b5e&scoped=true"
import script from "./orderTopInfo.vue?vue&type=script&lang=js"
export * from "./orderTopInfo.vue?vue&type=script&lang=js"
import style0 from "./orderTopInfo.vue?vue&type=style&index=0&id=5b3d9b5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3d9b5e",
  null
  
)

export default component.exports